import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { FlexLayoutType } from '../../constants/flex-layout.type';
import { StatusType } from '../../constants/status.type';
import { StatusTextType } from '../../constants/status-text.type';
import { HearingRequestDetailsModel } from '../../models/hearing-request-details.model';
import { HearingMethodType } from '../../constants/hearing-method.type';
@Component({
  selector: 'jsg-jsc-action-search-card-view',
  templateUrl: './jsc-action-search-card-view.component.html',
  styleUrls: ['./jsc-action-search-card-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JscActionSearchCardViewComponent {
  @Input() headerText: string;
  @Input() descriptionText: string;
  @Input() styleOfCause: string;
  @Input() judicialCenter: string;
  @Input() areaOfLaw: string;
  @Input() canViewAction: boolean = false;

  @Output() viewAction = new EventEmitter();

  public FlexLayoutType = FlexLayoutType;
  public StatusType = StatusType;
  public StatusTextType = StatusTextType;
  public HearingMethodType = HearingMethodType;

  constructor() {}

  public onViewAction = () => {
    this.viewAction.emit();
  };
}
